// The Studio edits canonical English Journey content and does not need the
// patient application's browser language detector or translation backends.
// Shared Journey runtime code only relies on i18n.t; returning defaultValue
// preserves the reviewed English source in Studio previews.
const studioI18n = Object.freeze({
  t(key, options = {}) {
    return options.defaultValue ?? key;
  },
});

export default studioI18n;
